import React, { useState, useEffect } from 'react'

import {
	Button,
	Dialog,
	DialogTitle,
	DialogContent,
	DialogActions,
	ListItemText,
	MenuItem,
	TextField,
	Typography
} from '@material-ui/core'

import { Autocomplete } from '@material-ui/lab'

import { makeStyles } from '@material-ui/core/styles'

import { useDispatch } from 'react-redux'

import MaskedInput from 'react-text-mask'
import { showError } from '../../../actions/misc/misc.actions'

import { states } from '../../../services/helpers'
import clsx from 'clsx'

function TextMaskCustom(props) {
	const { inputRef, ...other } = props

	return (
		<MaskedInput
			{...other}
			ref={(ref) => {
				inputRef(ref ? ref.inputElement : null)
			}}
			mask={['(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]}
			placeholderChar={'\u2000'}
			showMask
		/>
	)
}

const useStyles = makeStyles((theme) => ({
	dialog: {
		'& .MuiDialog-paper': {
			maxWidth: '920px'
		}
	},
	formWrapper: {
		display: 'flex',
		flexDirection: 'column',
		margin: '24px 0px'
	},
	doubleGroup: {
		display: 'flex'
	},
	fieldWrapper: {
		'&:nth-child(odd)': {
			marginRight: '25px'
		},
		display: 'flex',
		flexDirection: 'column',
		marginBottom: '20px'
	},

	tripleGroup: {
		display: 'flex',
		justifyContent: 'space-between',
		'& .field-wrapper': {
			'&:nth-child(odd)': {
				marginRight: '0px'
			}
		},
		'& .field-wrapper .MuiTextField-root': {
			minWidth: 279,
			'& .MuiFilledInput-underline': {
				minWidth: 279
			}
		}
	},
	dialogActions: {
		justifyContent: 'space-between'
	},
	actionsWrapper: {
		display: 'flex',
		'& .MuiButton-root:nth-child(n + 2)': {
			marginLeft: '16px'
		}
	}
}))

const EditAddOnDialog = (props) => {
	const classes = useStyles()
	const dispatch = useDispatch()

	const { isShown, setIsShown, pet, setPet, onSave, onCancel } = props

	const [name, setName] = useState('')
	const [phone, setPhone] = useState('')
	const [address_line_1, setAddressLineOne] = useState('')
	const [address_line_2, setAddressLineTwo] = useState('')
	const [city, setCity] = useState('')
	const [zip_code, setZipcode] = useState('')
	const [state, setState] = useState('')
	const [email, setEmail] = useState('')
	const [hasFormErrors, setHasFormErrors] = useState(false)

	const [nameError, setNameError] = useState(false)
	const [phoneError, setPhoneError] = useState(false)

	useEffect(() => {
		if (isShown) if (props.name) setName(props.name)
		if (pet.vet_clinic) setName(pet.vet_clinic)
		if (pet.vet_phone) setPhone(pet.vet_phone)
		if (pet.vet_address) setAddressLineOne(pet.vet_address)
		if (pet.vet_address_2) setAddressLineTwo(pet.vet_address_2)
		if (pet.vet_city) setCity(pet.vet_city)
		if (pet.vet_zip_code) setZipcode(pet.vet_zip_code)
		if (pet.vet_state) setState(pet.vet_state)
		if (pet.vet_email) setEmail(pet.vet_email)
	}, [isShown])

	const hideDialog = () => {
		clearForm()
		clearFormErrors()
		setIsShown(false)
	}

	const clearForm = () => {
		setName('')
		setPhone('')
		setAddressLineOne('')
		setAddressLineTwo('')
		setCity('')
		setZipcode('')
		setState('')
		setEmail('')

		clearFormErrors()
	}

	const clearFormErrors = () => {
		setNameError(false)
		setPhoneError(false)
		setHasFormErrors(false)
	}

	const addVet = () => {
		let hasErrors = validate()

		if (hasErrors) {
			setHasFormErrors(true)
			dispatch(showError('Please fix form errors.'))
		} else {
			let updates = {
				vet_clinic: name,
				vet_email: email,
				vet_phone: phone,
				vet_address: address_line_1,
				vet_address_2: address_line_2,
				vet_city: city,
				vet_zip_code: zip_code,
				vet_state: state
			}

			setPet({ ...pet, ...updates })

			setHasFormErrors(false)

			if (onSave) {
				onSave()
			}

			hideDialog()
		}
	}

	const validate = () => {
		if (!name) setNameError(true)
		if (!phone) setPhoneError(true)

		return !name || !phone
	}

	useEffect(() => {
		if (hasFormErrors) {
			let hasErrors = validate()

			if (!hasErrors) {
				setHasFormErrors(false)
			}
		}
	})

	useEffect(() => {
		return () => {
			clearForm()
		}
	}, [isShown])

	return (
		<Dialog
			open={isShown}
			onClose={() => hideDialog()}
			aria-labelledby="form-dialog-title"
			className={classes.dialog}>
			<DialogTitle>
				<Typography
					style={{
						marginBottom: '16px',
						fontSize: '1.4063rem',
						fontWeight: 700
					}}>
					Add Veterinarian
				</Typography>
			</DialogTitle>
			<DialogContent>
				<div className={classes.formWrapper}>
					<div className={classes.doubleGroup}>
						<div className={clsx([classes.fieldWrapper, 'field-wrapper'])}>
							<TextField
								id="name"
								variant="filled"
								required
								label="Name"
								value={name}
								onChange={(e) => {
									if (nameError && e.target.value) {
										setNameError(false)
									}

									setName(e.target.value)
								}}
								error={nameError}
								helperText={nameError ? 'Please enter a name.' : null}
							/>
						</div>
						<div className={clsx([classes.fieldWrapper, 'field-wrapper'])}>
							<TextField
								id="phone"
								variant="filled"
								required
								label="Phone"
								InputProps={{
									inputComponent: TextMaskCustom
								}}
								value={phone}
								onChange={(e) => {
									if (phoneError && e.target.value) {
										setPhoneError(false)
									}

									setPhone(e.target.value)
								}}
								error={phoneError}
								helperText={phoneError ? 'Please enter a phone number.' : null}
							/>
						</div>
					</div>
					<div className={classes.doubleGroup}>
						<div className={clsx([classes.fieldWrapper, 'field-wrapper'])}>
							<TextField
								id="address-one"
								variant="filled"
								label="Address 1"
								value={address_line_1}
								onChange={(e) => {
									setAddressLineOne(e.target.value)
								}}
							/>
						</div>
						<div className={clsx([classes.fieldWrapper, 'field-wrapper'])}>
							<TextField
								id="address-two"
								variant="filled"
								label="Address 2"
								value={address_line_2}
								onChange={(e) => setAddressLineTwo(e.target.value)}
							/>
						</div>
					</div>
					<div className={classes.tripleGroup}>
						<div className={clsx([classes.fieldWrapper, 'field-wrapper'])}>
							<TextField
								id="city"
								variant="filled"
								label="City"
								value={city}
								onChange={(e) => {
									setCity(e.target.value)
								}}
							/>
						</div>
						<div className={clsx([classes.fieldWrapper, 'field-wrapper'])}>
							<Autocomplete
								size="small"
								getOptionLabel={(option) => option.name}
								id="household-select"
								className={classes.autoComplete}
								options={states || []}
								value={state ? states.find((s) => s.id === state) : ''}
								onChange={(e, v) => {
									if (v) {
										setState(v.id)
									}
								}}
								onClose={(e) => {
									e.target.value = ''
								}}
								renderOption={(option) => (
									<React.Fragment>
										<ListItemText primary={option.name} />
									</React.Fragment>
								)}
								renderInput={(params) => <TextField {...params} variant="filled" label="State" />}
								onKeyPress={(e, v) => {
									if (e.key === 'enter') {
										setState(v.id)
									}
								}}
							/>
						</div>
						<div className={clsx([classes.fieldWrapper, 'field-wrapper'])}>
							<TextField
								id="zipcode"
								variant="filled"
								label="Zip"
								value={zip_code}
								onChange={(e) => {
									setZipcode(e.target.value)
								}}
							/>
						</div>
					</div>
					<div className={classes.doubleGroup}>
						<div className={clsx([classes.fieldWrapper, 'field-wrapper'])}>
							<TextField
								id="email"
								variant="filled"
								label="Email"
								value={email}
								onChange={(e) => setEmail(e.target.value)}
							/>
						</div>
					</div>
				</div>
			</DialogContent>
			<DialogActions className={classes.dialogActions}>
				<Button
					variant="contained"
					onClick={() => {
						addVet()
					}}
					color="secondary"
					disabled={hasFormErrors}>
					Save
				</Button>
				<Button
					variant="outlined"
					onClick={() => {
						if (onCancel) {
							onCancel()
						}

						hideDialog()
					}}
					color="secondary">
					Cancel
				</Button>
			</DialogActions>
		</Dialog>
	)
}

export default EditAddOnDialog
